import { post, get, put, del } from '../axios';
import CryptoJS from 'crypto-js';

export const encryptData = (data, key = "dahui,encode,yga") => {
  try {
    const cryptoKey = CryptoJS.enc.Utf8.parse(key);
    const encrypted = CryptoJS.AES.encrypt(data, cryptoKey, {
      mode: CryptoJS.mode.CFB,
      padding: CryptoJS.pad.NoPadding,
      iv: cryptoKey
    })

    return encrypted.toString()

  } catch (error) {
    console.error('加密失败:', error)
    throw error
  }
}

/**
 * 用户认证相关 API
 */
export const login = (username, password) => {
  return post('/auth/login', {
    username,
    password
  }).then(response => {
    const { access_token, refresh_token, user } = response.data
    localStorage.setItem('access_token', access_token)
    localStorage.setItem('refresh_token', refresh_token)
    localStorage.setItem('user_info', JSON.stringify(user))
    return response.data
  })
}

export const loginPhone = (username, password) => {
  const credentials = "customer-app:customer-app";
  const base64Credentials = window.btoa(credentials);

  const payload = {
    grant_type: "phone_pwd",
    phone: username,
    password: encryptData(password),
    scope: "server"
  }

  return post('/api/account/oauth2/token',
    payload,
    {
      headers: {
        skipToken: true,
        Authorization: `Basic ${base64Credentials}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    },
  ).then(response => {
    // const { access_token, refresh_token, user } = response.data
    // localStorage.setItem('access_token', access_token)
    // localStorage.setItem('refresh_token', refresh_token)
    // localStorage.setItem('user_info', JSON.stringify(user))
    return response
  })
}

export const loginByCode = (username, code) => {
  const credentials = "customer-app:customer-app";
  const base64Credentials = window.btoa(credentials);

  const payload = {
    grant_type: "phone_code",
    phone: username,
    code: code,
    scope: "server"
  }

  return post('/api/account/oauth2/token',
    payload,
    {
      headers: {
        skipToken: true,
        Authorization: `Basic ${base64Credentials}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    },
  ).then(response => {
    return response
  })
}


export const adminLoginName = (username, password) => {
  const credentials = "admin-app:admin-app";
  const base64Credentials = window.btoa(credentials);

  const payload = {
    grant_type: "username_pwd",
    username: username,
    password: encryptData(password),
    scope: "server"
  }

  return post('/api/account/oauth2/token',
    payload,
    {
      headers: {
        skipToken: true,
        Authorization: `Basic ${base64Credentials}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    },
  ).then(response => {
    // const { access_token, refresh_token, user } = response.data
    // localStorage.setItem('access_token', access_token)
    // localStorage.setItem('refresh_token', refresh_token)
    // localStorage.setItem('user_info', JSON.stringify(user))
    return response
  })
}

export const register = (userData) => {
  return post('/auth/register', userData)
}

export const getVerificationCode = data => {
  return post(`/api/account/send-verification-code`, data)
}



export const logout = () => {
  return post('/auth/logout').finally(() => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user_info')
  })
}

export const logoutDelete = () => {
  return del(`/api/account/token/logout`)
}

/**
 * 用户信息相关 API
 */
// export const getUserInfo = () => {
//   return get('/user/profile')
// }

export const getUserInfo = () => {
  return get('/api/my-yugong/profile/info')
}

export const updateUserInfo = (userData) => {
  return put('/user/profile', userData)
}

export const changePassword = (oldPassword, newPassword) => {
  return post('/user/change-password', {
    old_password: oldPassword,
    new_password: newPassword
  })
}

export const getAdminUserInfo = () => {
  return get('/api/admin/user/info')
}

export const depositRechargeCheck = () => {
  return get('/api/my-yugong/deposit/recharge-check')
}

export const depositRecharge = ({ amount, channel }) => {
  return post('/api/my-yugong/deposit/recharge', {
    amount,
    channel
  })
}

export const checkPaymentStatus = trackNumber => {
  return get(`/api/my-yugong/payment/status/${trackNumber}`)
}

export const refundDeposit = () => {
  return post('/api/my-yugong/deposit/refund')
}

/**
 * 管理员用户管理 API
 */
export const getUserList = (params = {}) => {
  return get('/admin/users', params)
}

export const updateUserStatus = (userId, status) => {
  return put(`/admin/users/${userId}/status`, { status })
}

export const resetUserPassword = (userId) => {
  return post(`/admin/users/${userId}/reset-password`)
}

//to do paging
export const getMyPurchasedLots = (status = '', page = 1, size = 100) => {
  return get(`api/my-yugong/bought?status=${status}&page=${page}&size=${size}`)
}

export const getMyPurchasedLotDetail = (id) => {
  return get(`api/my-yugong/bought/${id}/detail`)
}

export const getUserDeposit = () => {
  return get(`/api/my-yugong/deposit/account-info`)
}

export const getUserDepositList = (page = 1, size = 100, type = '') => {
  return get(`/api/my-yugong/deposit/account-details?page=${page}&size=${size}&type=${type}`)
}

/* my favorites */
export const getFavouriteAuctions = (page = 1, size = 100) => {
  return get(`/api/my-yugong/favorites/auctions?page=${page}&size=${size}`)
}

export const getFavouriteLots = (page = 1, size = 100) => {
  return get(`/api/my-yugong/favorites/lots?page=${page}&size=${size}`)
}

export const addMyFavouriteLot = id => {
  return post('/api/my-yugong/favorites', {
    targetType: 1,
    targetId: id
  })
}

export const addMyFavouriteAuction = id => {
  return post('/api/my-yugong/favorites', {
    targetType: 0,
    targetId: id
  })
}

export const removeMyFavouriteLot = id => {
  del(`/api/my-yugong/favorites`, {
    targetType: 1,
    targetId: id
  })
}

export const removeMyFavouriteAuction = id => {
  del(`/api/my-yugong/favorites`, {
    targetType: 0,
    targetId: id
  })
}

export const getMyBids = (page = 1, size = 100) => {
  return get(`/api/my-yugong/bids/history?page=${page}&size=${size}`)
}

export const getMyPaddleHistoryNumbers = (page = 1, size = 100) => {
  return get(`/api/my-yugong/paddles/history?page=${page}&size=${size}`)
}

export const getMyPaddleNumbers = (page = 1, size = 100) => {
  return get(`/api/my-yugong/paddles/calender?page=${page}&size=${size}`)
}

export const getClientLiveCurrentAuctionLot = id => {
  return get(`/api/auction/sale/${id}/live-lot`)
}

export const getLiveAuctionProgress = id => {
  return get(`/api/auction/sale/${id}/session-view`)
}

export const getNextBidPrice = (auctionId, price, offset) => {
  return get(`/api/auction/sale/${auctionId}/next-bid?currentBid=${price}&offset=${offset}`)
}

export const getUserQualification = auctionId => {
  return get(`/api/my-yugong/sale/${auctionId}/qualification`)
}

export const placeBid = (auctionId, lotId, bid) => {
  return post(`/api/my-yugong/sale/${auctionId}/lot/${lotId}/place-bid`, {
    bid: bid
  })
}

export const getWSConnectionTicket = () => {
  return get(`/api/auction/ws-ticket`)
}

export const initiateSettlement = orderIds => {
  return post(`/api/my-yugong/bought/initiate-settlement`, {
    orderIds: orderIds
  })
}

export const getAddressList = () => {
  return get(`/api/my-yugong/profile/address/list`)
}

export const proceedToPayment = data => {
  return post(`/api/my-yugong/bought/proceed-to-payment`, {
    ...data
  })
}

export const identityVerifyCheck = () => {
  return get(`/api/my-yugong/profile/identity-verify-check`)
}

export const identityUpload = data => {
  return post('/api/my-yugong/profile/identity/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const identityRecognize = data => {
  return post('/api/my-yugong/profile/identity/recognize', data)
}

export const getEsignIdentity = data => {
  return post('/api/my-yugong/profile/identity/authorize', data)
}

export const checkPaddleStatus = auctionId => {
  return get(`/api/my-yugong/paddles/registration-check?auctionId=${auctionId}`)
}

export const initiateSigning = data => {
  return post('/api/my-yugong/paddles/initiate-signing', data)
}

export const registerByPhone = data => {
  return post('/api/account/register-by-phone', data)
}

export const getPurchasedDetail = id => {
  return get(`/api/my-yugong/bought/${id}/detail`)
}

export const getAvailableFapiao = () => {
  return get(`/api/my-yugong/invoice/orders`)
}

export const getAppliedFapiao = (page = 1, size = 100) => {
  return get(`/api/my-yugong/invoice/records?size=${size}&page=${page}`)
}

export const getAppliedFapiaoDetail = (id) => {
  return get(`/api/my-yugong/invoice/${id}/detail`)
}

export const proposeFapiao = orderIds => {
  return post('/api/my-yugong/invoice/propose', { orderIds })
}

export const submitFapiao = (id, data) => {
  return post(`/api/my-yugong/invoice/${id}/submit`, data)
}

export const cancelFapiao = (id) => {
  return put(`/api/my-yugong/invoice/${id}/revoke`)
}

export const addAddress = data => {
  return post(`/api/my-yugong/profile/address`, data)
}

export const updateAddress = (id, data) => {
  return put(`/api/my-yugong/profile/address/${id}`, data)
}

export const deleteAddress = (id) => {
  return del(`/api/my-yugong/profile/address/${id}`)
}

export const getLotCertificate = (id) => {
  return get(`/api/my-yugong/bought/${id}/certificate`, {}, { responseType: 'blob' })
}

export const getLiveVideoSrcUrl = (id) => {
  return get(`/api/auction/sale/${id}/live-play-url`)
}


export const updateEmail = data => {
  return put(`/api/my-yugong/profile/email`, data)
}

export const sendCertificateToEmail = orderId => {
  return post(`/api/my-yugong/bought/${orderId}/send-certificate`)
}